import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const menuTemplate = document.createElement('template')
menuTemplate.innerHTML = `
    <wa-button
      size="small"
      appearance="plain"
      variant="neutral"
      aria-haspopup="true"
      aria-expanded="false"
      aria-controls="profile-dropdown"
      class="contextual-link-btn"
      with-caret>
        <slot name="buttonText"></slot>
    </wa-button>
    <transition name="dropdown-fade">
      <wa-tree class="dropdown-menu mt-1 closed">
        <slot></slot>
      </wa-tree>
    </transition>
`

class NavHeaderPrimaryMenu extends HTMLElement {
  private handleOutsideClick: (event: MouseEvent) => void

  constructor() {
    super()

    tryLoadDependencies(document, [
      WebAwesomeComponent.Button,
      WebAwesomeComponent.Tree,
      WebAwesomeComponent.TreeItem,
    ])

    this.handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  connectedCallback() {
    const hasButtonText = this.querySelector('[slot="buttonText"]')

    if (hasButtonText) {
      // ========== MODE A: Primary Menu ==========

      const shadow = this.attachShadow({ mode: 'open' })
      shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
      shadow.appendChild(menuTemplate.content.cloneNode(true))

      const btn = shadow.querySelector('wa-button')
      if (btn) {
        btn.addEventListener('click', () => this.toggleMenu())
      }
    } else {
      // ========== MODE B: Container (Structure 1) ==========
      // Do nothing → NO shadow DOM, element acts like a wrapper
    }
  }

  disconnectedCallback() {
    document.removeEventListener('mousedown', this.handleOutsideClick)
  }

  private _handleOutsideClick(event: MouseEvent) {
    if (!this.contains(event.target as Node)) {
      this.closeMenu()
    }
  }

  private toggleMenu() {
    const panel = this.shadowRoot?.querySelector('wa-tree')
    const btn = this.shadowRoot?.querySelector('wa-button')
    if (panel && btn) {
      panel.classList.toggle('closed')
      btn.classList.toggle('menu-active')
      if (!panel.classList.contains('closed')) {
        document.addEventListener('mousedown', this.handleOutsideClick)
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick)
      }
    }
  }

  private closeMenu() {
    const panel = this.shadowRoot?.querySelector('wa-tree')
    const btn = this.shadowRoot?.querySelector('wa-button')
    if (panel && !panel.classList.contains('closed')) {
      panel.classList.toggle('closed')
      btn?.classList.remove('menu-active')
    }
  }
}

customElements.define('ts-navheader-contextual-menu', NavHeaderPrimaryMenu)
